import * as React from 'react';

const Clock = ({ ...props }) => (
    <svg
        width="16"
        height="24"
        viewBox="0 0 16 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <circle cx="8" cy="12" r="7.5" stroke="currentColor" />
        <path d="M7 8V13H12" stroke="currentColor" />
    </svg>
);

export default Clock;
